<template>
  <v-card
    color="blue-grey darken-2"
    class="white--text"
    v-if="bankAccount && bankAccount.bank_account"
  >
    <v-container grid-list-md fluid>
      <v-layout class="row wrap align-center justify-end row fill-height">
        <v-flex xs12 sm12 md4>
          <div>
            <span class="font-weight-bold">Parceiro</span>
            <!-- <div class="headline" v-if="bankAccount && bankAccount.register_information">{{bankAccount.register_information.company_name}}</div> -->
            <div class="headline">{{ partner.name }}</div>
            <div>ID#{{ partner.recipient_id }}</div>
            <div v-if="partner.url">Acesso: {{ partner.url }}</div>
          </div>
        </v-flex>
        <v-flex xs12 sm12 md4>
          <div>
            <span class="font-weight-bold">Dados Bancarios</span>
            <div v-if="bankAccount && bankAccount.bank_account">
              {{
                "Banco: " +
                bankAccount.bank_account.bank_code +
                " | Agência: " +
                bankAccount.bank_account.agencia +
                " | Conta: " +
                bankAccount.bank_account.conta +
                "-" +
                bankAccount.bank_account.conta_dv
              }}
            </div>
            <div
              v-if="
                bankAccount &&
                bankAccount.register_information &&
                bankAccount.register_information.type === 'individual'
              "
            >
              Titular: {{ bankAccount.register_information.name }}
            </div>
            <div
              v-if="
                bankAccount &&
                bankAccount.register_information &&
                bankAccount.register_information.type !== 'individual'
              "
            >
              Titular: {{ bankAccount.register_information.company_name }}
            </div>
            <!-- <div class="headline" v-if="bankAccount && bankAccount.register_information">{{bankAccount.register_information.company_name}}</div> -->
            <div v-if="bankAccount && bankAccount.bank_account">
              {{
                bankAccount.bank_account.document_type.toUpperCase() +
                ": " +
                bankAccount.bank_account.document_number
              }}
            </div>
          </div>
        </v-flex>
        <v-flex xs12 sm12 md4> </v-flex>
        <v-flex xs12 sm12 md4>
          <v-card class="white black--text">
            <v-card-title primary-title>
              <div>
                <span class="grey--text text--darken-3">Saldo Atual</span>
                <div v-if="!loading" class="headline pt-2">
                  R$ {{ available | formatCurrency }}
                </div>
                <div v-else class="headline pt-2 pb-4">
                  R$
                  <v-progress-circular
                    indeterminate
                    color="primary"
                  ></v-progress-circular>
                </div>
                <span v-if="!loading" class="green--text text--darken-3"
                  >Disponível para saques R$
                  {{ available | formatCurrency }}.</span
                >
              </div>
            </v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <!-- <v-btn color="green" small dark round class="font-weight-bold" @click.prevent="dialog = true">Sacar</v-btn> -->
            </v-card-actions>
          </v-card>
        </v-flex>
        <v-flex xs12 sm12 md4>
          <v-card class="white black--text">
            <v-card-title primary-title>
              <div>
                <span class="grey--text text--darken-3">A receber</span>
                <div v-if="!loading" class="headline pt-2 pb-4">
                  R$ {{ waiting_funds | formatCurrency }}
                </div>
                <div v-else class="headline pt-2 pb-4">
                  R$
                  <v-progress-circular
                    indeterminate
                    color="primary"
                  ></v-progress-circular>
                </div>
                <span class="grey--text text--darken-2"
                  >Pagamentos em cartão de crédito levam 30 dias para
                  liberação.</span
                >
              </div>
            </v-card-title>
          </v-card>
        </v-flex>
        <v-flex xs12 sm12 md4>
          <v-card class="white black--text">
            <v-card-title primary-title>
              <div>
                <span class="grey--text text--darken-3">Saques</span>
                <div v-if="!loading" class="headline pt-2 pb-4">
                  R$ {{ transferred | formatCurrency }}
                </div>
                <div v-else class="headline pt-2 pb-4">
                  R$
                  <v-progress-circular
                    indeterminate
                    color="primary"
                  ></v-progress-circular>
                </div>
                <span class="grey--text text--darken-2"
                  >Valor total transferido para a conta bancaria da
                  empresa.</span
                >
              </div>
            </v-card-title>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog v-model="dialog" persistent max-width="400px">
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-card>
          <v-card-title>
            <span class="headline"
              ><v-icon left color="green">account_balance</v-icon>SAQUE</span
            >
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm12 md12 class="text-xs-center">
                  <div class="font-weight-medium">
                    DIGITE O VALOR QUE DESEJA SACAR
                  </div>
                  <div class="">
                    Saldo disponível
                    <span class="green--text font-weight-bold"
                      >R$ {{ available | formatCurrency }}</span
                    >
                  </div>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <v-text-field
                    label="Valor do Saque*"
                    required
                    v-model.number="transferValue"
                    type="number"
                    prefix="R$"
                    :rules="[
                      (v) => !!v || 'Informe o valor do saque',
                      (v) =>
                        v <= this.available ||
                        'Valor solicitado maior que o saldo disponivel (R$ ' +
                          this.available +
                          ')',
                      (v) =>
                        v > 3.67 ||
                        'Valor solicitado é menor do que o custo (R$ 3,67)',
                    ]"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <v-card flat>
                    <v-list subheader>
                      <v-subheader
                        >Data de saída {{ new Date() | formatarDate }}
                      </v-subheader>
                      <v-list-tile>
                        <!-- <v-list-tile-avatar>
										<img :src="item.avatar">
										</v-list-tile-avatar> -->

                        <v-list-tile-content>
                          <v-list-tile-title
                            >Valor solicitado</v-list-tile-title
                          >
                        </v-list-tile-content>

                        <v-list-tile-action>
                          <!-- <v-icon :color="item.active ? 'teal' : 'grey'">chat_bubble</v-icon> -->
                          R$ {{ transferValue | formatCurrency }}
                        </v-list-tile-action>
                      </v-list-tile>
                      <v-list-tile>
                        <!-- <v-list-tile-avatar>
										<img :src="item.avatar">
										</v-list-tile-avatar> -->

                        <v-list-tile-content>
                          <v-list-tile-title
                            >Custo da transferência</v-list-tile-title
                          >
                        </v-list-tile-content>

                        <v-list-tile-action>
                          <!-- <v-icon :color="item.active ? 'teal' : 'grey'">chat_bubble</v-icon> -->
                          - R$ 3,67
                        </v-list-tile-action>
                      </v-list-tile>
                      <v-list-tile>
                        <!-- <v-list-tile-avatar>
										<img :src="item.avatar">
										</v-list-tile-avatar> -->

                        <v-list-tile-content>
                          <v-list-tile-title
                            >Valor a ser transferido</v-list-tile-title
                          >
                        </v-list-tile-content>

                        <v-list-tile-action>
                          <!-- <v-icon :color="item.active ? 'teal' : 'grey'">chat_bubble</v-icon> -->
                          <span class="blue--text darken-2 font-weight-medium"
                            >R$
                            {{ (transferValue - 3.67) | formatCurrency }}</span
                          >
                        </v-list-tile-action>
                      </v-list-tile>
                    </v-list>
                  </v-card>
                  <div class="pt-3 red--text text-xs-center font-weight-medium">
                    Atenção essa ação é irreversivel, execute apenas se tiver
                    certeza
                  </div>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              dark
              color="red darken-1"
              class="font-weight-bold"
              @click="dialog = false"
              >Cancelar</v-btn
            >
            <v-btn
              color="green darken-1"
              @click="transfer(transferValue)"
              :loading="loading_saque"
              :disabled="!valid || loading_saque"
              >Sacar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-snackbar
      v-model="snackbar"
      :color="snackbar_color"
      multi-line="multi-line"
      :timeout="snackbar_timeout"
      top
    >
      {{ snackbar_message }}
      <v-btn dark flat @click="snackbar = false"> Fechar </v-btn>
    </v-snackbar>
  </v-card>
</template>
<script>
import {
  mapActions, //, mapGetters
  mapState,
  // mapMutations,
} from "vuex";

export default {
  data: () => ({
    available: 0,
    transferred: 0,
    waiting_funds: 0,
    dialog: false,
    transferValue: 0,
    loading_saque: false,
    snackbar: false,
    snackbar_color: "",
    snackbar_timeout: 0,
    snackbar_message: "",
    valid: false,
  }),
  computed: {
    ...mapState("extrato", [
      "balance",
      "partner",
      "bankAccount",
      "loading",
      "filter",
    ]),
  },
  mounted() {
    if (this.balance) {
      if (this.balance.available) {
        this.available = this.balance.available.amount / 100;
        this.transferValue = this.balance.available.amount / 100;
      }
      if (this.balance.transferred)
        this.transferred = this.balance.transferred.amount / 100;
      if (this.balance.waiting_funds)
        this.waiting_funds = this.balance.waiting_funds.amount / 100;
    }
  },
  watch: {
    balance(val) {
      if (val.available) this.available = val.available.amount / 100;
      if (val.transferred) this.transferred = val.transferred.amount / 100;
      if (val.waiting_funds)
        this.waiting_funds = val.waiting_funds.amount / 100;
    },
  },
  methods: {
    ...mapActions("extrato", ["createTransfer"]),
    transfer(amount) {
      this.loading_saque = true;
      if (amount <= 3.67) {
        console.error("Error: O saque deve ser maior que R$ 3,67");
        this.showSnackBar("red", "O saque deve ser maior que R$ 3,67");
        this.loading_saque = false;
        return;
      } else {
        let params = {};
        params.recipient_id = this.bankAccount.id;
        params.amount = (amount - 3.67) * 100;
        params.startDate = this.filter.startDate;
        params.endDate = this.filter.endDate;
        this.createTransfer(params)
          .then(() => {
            // console.log('_transfer: ' , _transfer)
            this.transferValue = 0;
            this.dialog = false;
            this.showSnackBar(
              "green",
              "Seu saque será encaminhado ao banco até o final do dia caso tenha sido feito até às 15h, no horário de Brasília. Após isso, ele será encaminhado somente no próximo dia útil.!",
            );
            this.loading_saque = false;
          })
          .catch((err) => {
            this.showSnackBar("red", "Erro ao realizar saque. " + err);
            console.error("Transfer Error: ", err);
            this.loading_saque = false;
          });
      }
    },
    showSnackBar(color, message) {
      this.snackbar_color = color || "green";
      this.snackbar_message = message;
      this.snackbar = true;
    },
  },
};
</script>
